import { Popover, ValidatedDropDownList, ValidatedInput } from '@finbeat/react-toolkit';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { changeStatus } from 'axios/orderApi';
import useApi from 'hooks/useApi';
import { OrderStatusChangeShort } from 'models/api/order';
import { useOrderLists } from 'providers/OrderListsProvider';
import { Trans, useTranslation } from 'react-i18next';

type OrderChangeStatusProps = {
    status: string;
    comment: string;
};

type OrderChangeStatusPopoverProps = {
    orderId: string;
    currentStatus: string;
};

const OrderChangeStatusPopover = ({ orderId, currentStatus }: OrderChangeStatusPopoverProps) => {
    const { orderStatuses } = useOrderLists();
    const { t } = useTranslation();
    const api = useApi();

    const mutationFunction = ({ status, comment }: OrderChangeStatusProps) => {
        const newStatus: OrderStatusChangeShort = {
            orderId: orderId,
            status: status,
            dsc: comment,
            reason: '',
            timeout: undefined,
            currentStatus: currentStatus,
        };
        return changeStatus(api, newStatus);
    };

    return (
        <Popover<OrderChangeStatusProps>
            label={'change-status'}
            textStyle={'warning'}
            buttonIcon={faWrench}
            buttonLabel={'BackOfficeManualStatusChange'}
            orderId={orderId}
            mutationFunction={mutationFunction}
            canSave={true}
            refetchQueryKeys={[['order'], 'orderStatusCount']}
            header={
                <>
                    <Trans i18nKey={'BackOfficeManualStatusChange'} /> #{orderId}
                </>
            }
            defaultValues={{
                status: currentStatus,
                comment: '',
            }}
        >
            <ValidatedDropDownList<OrderChangeStatusProps>
                items={orderStatuses}
                name="status"
                label={t('BackOfficeStatus')}
                menuPortalTarget={null}
                isClearable={false}
            />
            <ValidatedInput<OrderChangeStatusProps>
                id="info-comment-field"
                name="comment"
                type="textarea"
                label={t('BackOfficeComment')}
            />
        </Popover>
    );
};

export default OrderChangeStatusPopover;
